module.exports = __webpack_public_path__ + "img/online.c389e936.png";